// src/pages/admin/AdminFaqPage.jsx
import { useEffect, useState } from "react";
import styles from "./AdminSupport.module.css";

export default function AdminFaqPage() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [editingId, setEditingId] = useState(null);
  const [category, setCategory] = useState("");
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [sortOrder, setSortOrder] = useState(0);

  const resetForm = () => {
    setEditingId(null);
    setCategory("");
    setQuestion("");
    setAnswer("");
    setSortOrder(0);
  };

  const loadList = () => {
    setLoading(true);
    fetch("/api/support/faqs", { credentials: "include" })
      .then((res) => res.json())
      .then(setList)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadList();
  }, []);

  const handleEditClick = (faq) => {
    setEditingId(faq.id);
    setCategory(faq.category || "");
    setQuestion(faq.question || "");
    setAnswer(faq.answer || "");
    setSortOrder(faq.sortOrder || 0);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("이 FAQ를 삭제하시겠습니까?")) return;
    const res = await fetch(`/api/support/faqs/${id}`, {
      method: "DELETE",
      credentials: "include",
    });
    if (res.ok) {
      if (editingId === id) resetForm();
      loadList();
    } else {
      alert("삭제에 실패했습니다.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = { category, question, answer, sortOrder: Number(sortOrder) || 0 };

    const url = editingId
      ? `/api/support/faqs/${editingId}`
      : "/api/support/faqs";
    const method = editingId ? "PUT" : "POST";

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(body),
    });

    if (res.ok) {
      resetForm();
      loadList();
    } else {
      alert("저장에 실패했습니다.");
    }
  };

  return (
    <main className={styles.page}>
      <h1 className={styles.pageTitle}>FAQ 관리</h1>

      <div className={styles.split}>
        {/* 리스트 영역 */}
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>FAQ 목록</h2>
          </div>

          {loading ? (
            <p>로딩 중...</p>
          ) : (
            <div className={styles.scrollList}>
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <th style={{ width: "60px" }}>ID</th>
                      <th style={{ width: "120px" }}>카테고리</th>
                      <th style={{ textAlign: "left"}}>질문</th>
                      {/* 정렬 / 관리 컬럼은 가운데 정렬 + 폭 지정 */}
                      <th className={styles.centerCol} style={{ width: "80px" }}>정렬</th>
                      <th className={styles.centerCol} style={{ width: "120px" }}>관리</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((f) => (
                      <tr
                        key={f.id}
                        onClick={() => handleEditClick(f)}
                      >
                        <td>{f.id}</td>
                        <td>{f.category}</td>
                        <td style={{ textAlign: "left"}}>{f.question}</td>
                        {/* 정렬값 가운데 정렬 */}
                        <td className={styles.centerCol}>{f.sortOrder}</td>
                        {/* 관리 컬럼: 가운데 정렬 + 버튼용 셀 */}
                        <td className={`${styles.centerCol} ${styles.actionsCell}`}>
                          <button
                            type="button"
                            className={styles.smallBtnDanger}
                            onClick={(e) => {
                              e.stopPropagation(); // 행 클릭(수정) 막기
                              handleDelete(f.id);
                            }}
                          >
                            삭제
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
            </div>
          )}
        </section>

        {/* 작성/수정 폼 영역 */}
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>{editingId ? "FAQ 수정" : "FAQ 등록"}</h2>
            {editingId && (
              <button
                type="button"
                className={styles.smallBtn}
                onClick={resetForm}
              >
                새 FAQ 작성
              </button>
            )}
          </div>

          <form className={styles.form} onSubmit={handleSubmit}>
            <label>
              카테고리 (선택)
              <input
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                placeholder="예: 일반, 결제, 계정 등"
              />
            </label>

            <label>
              질문
              <input
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                required
              />
            </label>

            <label>
              답변
              <textarea
                rows={8}
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                required
              />
            </label>

            <label>
              정렬 순서
              <input
                type="number"
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
              />
            </label>

            <div className={styles.actions}>
              <button type="submit">
                {editingId ? "수정 저장" : "등록"}
              </button>
            </div>
          </form>
        </section>
      </div>
    </main>
  );
}
